import { render, staticRenderFns } from "./IconEdit.vue?vue&type=template&id=6835f5a7&scoped=true"
import script from "./IconEdit.vue?vue&type=script&lang=js"
export * from "./IconEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6835f5a7",
  null
  
)

export default component.exports